export default class GetAnioCursoById {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idAnioCurso) {
    try {
      const result = await this.#repository.getAnioCursoById(idAnioCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
